import React, { ReactElement, useContext, useEffect, useState } from 'react'
import Fieldset from '../../Common/Components/Fieldset'
import FormRow from '../../Common/Components/FormRow'
import Heading, { HeadingLevel } from '../../Common/Components/Heading'
import { ReportsFilterDeviceFilter } from '../../../../i18n'
import { ComboBoxAlt } from '../../Common/Components/ComboBox/ComboBoxAlt'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageContext, ReactState } from '../../Common/Contexts'
import { SelectOptions } from '../../Common/Components/Selects'
import { FilterDeviceTypeResponse } from './Types'
import { CACHE_TIME, deviceTypesURL } from '../../../NonReact/constants/ApiConstants'
import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { SelectOption } from '../../Common/Components/Selects/Types'
import { ANY_VALUE_STRING_NUMERIC } from '../../Common/Constants/DefaultValues'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

type Props = {
    deviceTypes: number[]
    setDeviceTypes: (newValue: number[]) => void
}

const DeviceFiltering: React.FC<Props> = ({ deviceTypes, setDeviceTypes }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(ReportsFilterDeviceFilter.NAME)

    const [deviceTypesOptions, setDeviceTypeOptions]: ReactState<SelectOptions<number>> = useState<
        SelectOptions<number>
    >([])

    useEffect((): void => {
        requestGetJSON<FilterDeviceTypeResponse[]>(deviceTypesURL, {
            cacheTime: CACHE_TIME
        })
            .then((response: JSONResponse<FilterDeviceTypeResponse[]>): FilterDeviceTypeResponse[] => [
                ...(response?.filter(
                    (deviceType: FilterDeviceTypeResponse): boolean => deviceType.ID === ANY_VALUE_STRING_NUMERIC
                ) ?? []),
                ...(response?.filter(
                    (deviceType: FilterDeviceTypeResponse): boolean => deviceType.ID !== ANY_VALUE_STRING_NUMERIC
                ) ?? [])
            ])
            .then((response: JSONResponse<FilterDeviceTypeResponse[]>): void => {
                setDeviceTypeOptions(
                    response?.map(
                        (deviceType: FilterDeviceTypeResponse): SelectOption<number> => ({
                            value: parseInt(deviceType.ID, 10),
                            label: deviceType.Description
                        })
                    ) ?? []
                )
            })
    }, [])

    const handleDeviceTypesChange = (newValue: number[]): void => {
        setDeviceTypes(newValue)
    }

    return (
        <Fieldset className='device-type-filtering'>
            <Heading level={HeadingLevel.ONE}>
                {language.get(ReportsFilterDeviceFilter.Device_Filter_SectionHeader)}
            </Heading>
            <FormRow>
                <ComboBoxAlt
                    multiple
                    label={language.get(ReportsFilterDeviceFilter.Device_Filter_Dropdown_Label)}
                    value={deviceTypes}
                    handleChange={(newValue: Nullable<number[] | number>): void => {
                        if (Array.isArray(newValue)) {
                            handleDeviceTypesChange(newValue)
                        }
                    }}
                    options={deviceTypesOptions}
                />
            </FormRow>
        </Fieldset>
    )
}

export default DeviceFiltering
